function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "day-cloudy-fog");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "24.3617045%",
  y1: "72.8710337%",
  x2: "63.6421593%",
  y2: "39.9796521%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#F2F2F2",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#CFCFCF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "72.5161778%",
  y1: "64.9090909%",
  x2: "8.66000803%",
  y2: "22.6545455%",
  id: "linearGradient-2"
}, React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "2%"
}), React.createElement("stop", {
  stopColor: "#FFFFFF",
  stopOpacity: 0,
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "day-cloudy-fog",
  transform: "translate(0.000000, 1.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#EFCC00",
  fillRule: "nonzero",
  cx: 84.5,
  cy: 51.1578564,
  r: 31.5
}), React.createElement("path", {
  d: "M84,0.657856446 L84,11.6578564",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M84,89.6578564 L84,100.657856",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M34,50.6578564 L45,50.6578564",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M123,50.6578564 L134,50.6578564",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M49,15.6578564 L57,23.6578564",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M112,77.6578564 L120,85.6578564",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M49,85.6578564 L57,77.6578564",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M112,23.6578564 L120,15.6578564",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M43.6759917,35.6578564 C59.8900952,35.6251993 74.7864611,44.5461385 82.3604414,58.8247795 C94.8397967,51.5578016 110.55339,52.8589125 121.656555,62.078561 C132.75972,71.2982096 136.871287,86.4591631 131.938648,99.9926488 C127.006009,113.526134 114.08701,122.52978 99.6311764,122.508714 L43.6759917,122.657856 C19.5544075,122.657856 0,103.182263 0,79.1579014 C0,55.1335396 19.5544075,35.6578564 43.6759917,35.6578564 Z",
  id: "Path",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero"
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "url(#linearGradient-2)",
  fillRule: "nonzero",
  transform: "translate(99.376091, 88.169323) rotate(-74.390000) translate(-99.376091, -88.169323) ",
  cx: 99.3760914,
  cy: 88.1693226,
  rx: 34.1705349,
  ry: 34.2478481
}), React.createElement("path", {
  d: "M80,131.657856 L105,131.657856",
  id: "Path",
  stroke: "#A5A9AA",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M25,131.657856 L67,131.657856",
  id: "Path",
  stroke: "#B9C1C6",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M68,143.657856 L96,143.657856",
  id: "Path",
  stroke: "#A5A9AA",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M35,143.657856 L54,143.657856",
  id: "Path",
  stroke: "#A5A9AA",
  strokeWidth: 3,
  strokeLinecap: "round"
})));

var SvgDayCloudyFog = function SvgDayCloudyFog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "136px",
    height: "147px",
    viewBox: "0 0 136 147",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDayCloudyFog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/day-cloudy-fog.3e429168.svg";
export { ForwardRef as ReactComponent };